import { Component, EventEmitter, Output } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { FindAndReplaceDialogComponent } from '../../dialogs/find-and-replace-dialog/find-and-replace-dialog.component';
declare const TXTextControl: any;

@Component({
  selector: 'tx-section-find-and-replace',
  templateUrl: './section-find-and-replace.component.html',
  styleUrls: ['./section-find-and-replace.component.scss'],
})
export class SectionFindAndReplaceComponent {
  constructor(private dialogService: DialogService) {}
  openFindModal() {
    this.dialogService.openFindReplaceDialog('find', () => {
      setTimeout(() => {
        TXTextControl.setEditMode(TXTextControl.EditMode.Edit);
        TXTextControl.setActivationState(TXTextControl.ActivationState.Activated);
        TXTextControl.focus();
      }, 100);
    });
  }
  openReplaceModal() {
    this.dialogService.openFindReplaceDialog('replace', () => {
      setTimeout(() => {
        TXTextControl.setEditMode(TXTextControl.EditMode.Edit);
        TXTextControl.setActivationState(TXTextControl.ActivationState.Activated);
        TXTextControl.focus();
      }, 100);
    });
  }
}
